import ProductsApi from '../../../api/ProductsApi';
import * as types from './ActionTypes';
import { IEditProduct } from "../Types";

export function loadProductsSuccess(productsResult: any[]) {
    return { type: types.LOAD_PRODUCTS_SUCCESS, productsResult };
}

export function loadProductsFailed(productsResult: string) {
    return { type: types.LOAD_PRODUCTS_FAILURE, productsResult };
}

export function getProducts() {
    return (dispatch: (result: any) => void) =>
        ProductsApi.getProducts()
            .then((result: any) => {
                dispatch(loadProductsSuccess(result));
            })
            .catch((error: string) => {
                dispatch(loadProductsFailed(error));
                throw error;
            });
}

export function createProductSuccess(productsResult: any) {
    return { type: types.CREATE_PRODUCT_SUCCESS, productsResult };
}

export function createProductFailed(productsResult: string) {
    return { type: types.CREATE_PRODUCT_FAILURE, productsResult };
}

export function createProduct(product: any) {
    return (dispatch: (result: any) => void) =>
        ProductsApi.createProduct(product)
            .then((result: any) => {
                dispatch(createProductSuccess(result));
            })
            .catch((error: string) => {
                dispatch(createProductFailed(error));
                throw error;
            });
}

export function editProductSuccess(productsResult: any) {
    return { type: types.EDIT_PRODUCT_SUCCESS, productsResult };
}

export function editProductFailed(productsResult: string) {
    return { type: types.EDIT_PRODUCT_FAILURE, productsResult };
}

export function editProduct(product: any) {
    return (dispatch: (result: any) => void) =>
        ProductsApi.editProduct(product)
            .then((result: any) => {
                dispatch(editProductSuccess(result));
            })
            .catch((error: string) => {
                dispatch(editProductFailed(error));
                throw error;
            });
}
